const Utils = {
  randomString: () => Math.random().toString(36).substr(2, 5),
};
export default Utils;